import React, { useState, useEffect } from 'react';
import MapComponent from './MapComponent';
import axios from 'axios';
import styled from 'styled-components';
import config from '../config/config';
import cacheService from '../services/cacheService';

const MapIntegrationContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const MapIntegration = ({ onPOIClick, selectedFilters }) => {
    const [allAmenities, setAllAmenities] = useState(null);

    useEffect(() => {
        const fetchAmenities = async () => {
            try {
                // Use cache service for amenities
                const amenitiesData = await cacheService.getAmenities();
                setAllAmenities(amenitiesData);
            } catch (error) {
                console.error('Error fetching amenities:', error);
            }
        };

        fetchAmenities();
    }, []);

    return (
        <MapIntegrationContainer>
            <MapComponent 
                selectedAmenities={selectedFilters} 
                allAmenities={allAmenities}
                onPOIClick={onPOIClick}
            />
        </MapIntegrationContainer>
    );
};

export default MapIntegration;
